import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./Components/Header/Header";
import ScrollToTop from "./Components/ScrollToTop";
import MadGamers from "./Pages/Businesses/MadGamers";
import YarnHeaven from "./Pages/Businesses/YarnHeaven";
import ComingSoon from "./Pages/ComingSoon";
import Contact from "./Pages/Contact";
import ESPER from "./Pages/E-Commerces/ESPER";
import TipsyMonkey from "./Pages/E-Commerces/TipsyMonkey";
import Home from "./Pages/Home";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/soon" element={<ComingSoon />} />

        {/* E-COMMERCE ROUTES */}
        <Route path="/commerce/esper" element={<ESPER />} />
        <Route path="/commerce/tipsy" element={<TipsyMonkey />} />

        {/* BUSINESS ROUTES */}
        <Route path="/business/mad_gamers" element={<MadGamers />} />
        <Route path="/business/yarn_heaven" element={<YarnHeaven />} />
      </Routes>
    </Router>
  );
}

export default App;
